module.exports = __webpack_public_path__ + "img/logo-bold-beta.242d4eb2.png";